import React, { useEffect, useMemo, useState } from 'react';

import { useHistory } from 'react-router-dom';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';

import { makeStyles } from '@material-ui/core/styles';
import Toolbar from '@material-ui/core/Toolbar';
import Paper from '@material-ui/core/Paper';
import AppBar from '@material-ui/core/AppBar';

import { URLS } from 'app/config/urls';
import UserPopover from '../UserPopover';
import generalEndpoints from '../../api/services/generalEndpoints';
import pesquisa from 'app/components/Indecx/pesquisa';

import styles from './styles';
import { useDispatch, useSelector } from 'react-redux';
import { downloadFile } from 'app/utils/forms/files';
import { FormattedMessage } from 'react-intl';
import { fetchUserAdmin } from 'app/store/slices/user';
import { CircularProgress } from '@material-ui/core';
import MenuDev from '../MenuDev';
import { DEV_ENVIRONMENT } from 'app/utils/constants';
const useStyles = makeStyles(styles);

function Header(props) {
    const dispatch = useDispatch();
    const history = useHistory();
    const classes = useStyles();
    const [hasCRC, setHasCRC] = useState(false);
    const [loading, setLoading] = useState(false);

    const user = useSelector((state) => state.auth.user);
    const userAdmin = useSelector((state) => state.auth.userAdmin);
    const settings = useSelector((state) => state.settings.settings);
    const activeCompany = useSelector((state) => state.company.activeCompany);

    const companyData = useMemo(() => {
        if (activeCompany && Object.keys(activeCompany).length > 0) {
            if (
                activeCompany.boSituacaoOrgao &&
                activeCompany.certificado?.idFileCrc &&
                activeCompany.certificado?.idFileCrc !== ''
            ) {
                setHasCRC(true);
            }
            return activeCompany;
        } else if (user.cdUsuarioAdmin) {
            return userAdmin;
        }
        return {};
    }, [activeCompany, user.cdUsuarioAdmin, userAdmin]);

    const name = useMemo(() => {
        if (activeCompany.deRazaoSocial) {
            return activeCompany.deRazaoSocial;
        }
        if (activeCompany.nmCompleto) {
            return activeCompany.nmCompleto;
        }
        if (userAdmin.nmUsuario) {
            return userAdmin.nmUsuario;
        }
        return user.nmusuario || user.name || user.username;
    }, [activeCompany, user, userAdmin]);

    const email = useMemo(() => {
        if (activeCompany.deEmail) {
            return activeCompany.deEmail;
        }
        if (userAdmin.deEmail) {
            return userAdmin.deEmail;
        }
        return user.email;
    }, [activeCompany, user, userAdmin]);

    const handleProfile = () => {
        history.push(URLS.CHANGE_PASSWORD);
    };

    const goToCompany = () => {
        if (Object.keys(activeCompany).length > 0) {
            history.push(URLS.COMPANY);
        }
    };

    useEffect(() => {
        (async () => {
            if (user.cdUsuarioAdmin && Object.keys(userAdmin).length === 0) {
                setLoading(true);
                await dispatch(fetchUserAdmin(user.cdUsuarioAdmin));
                setLoading(false);
            }
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, user.cdUsuarioAdmin]);

    //pesquisa de satisfacao - Indecx
    useEffect(() => {
        if (!user?.username) return;
        const load = async () => {
            const indecxKey = await generalEndpoints.getIndecxExternalKey();
            if (indecxKey?.status === 200 && indecxKey?.data) {
                const { key, action } = indecxKey.data;
                pesquisa(user, key, action);
            }
        };
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user?.username]);

    return (
        <Paper elevation={4}>
            <AppBar position="static" color="default" className={classes.containerHeader}>
                <Toolbar>
                    <div className={classes.logo}>
                        <img
                            src={settings.logo}
                            alt="logo"
                            onClick={() => history.push(URLS.START)}
                            style={{ cursor: 'pointer' }}
                        />
                        <div onClick={() => history.push(URLS.START)} style={{ cursor: 'pointer' }}>
                            <span className={[classes.spanPortalName, classes.color1].join(' ')}>Portal</span>
                            <span className={[classes.spanPortalName, classes.color2].join(' ')}>de</span>
                            <span className={[classes.spanPortalName, classes.color3].join(' ')}>Serviços</span>
                        </div>
                        <div className={classes.orgName}></div>
                    </div>
                    <div className={classes.profile}>
                        <div className={classes.crcIcon}>
                            {hasCRC && (
                                <Paper
                                    className={classes.crc}
                                    elevation={0}
                                    square={true}
                                    onClick={async () =>
                                        await downloadFile(
                                            { idFile: companyData.certificado?.idFileCrc, dispatch },
                                            null,
                                        )
                                    }>
                                    <div className={classes.iconCrc}>
                                        <InsertDriveFileIcon className={classes.icon} />
                                    </div>
                                    <div className={classes.infosCrc}>
                                        <h3>
                                            <FormattedMessage id="LABELS.COMPANY.CRC" />
                                        </h3>
                                        <h4>
                                            <FormattedMessage id="LABELS.COMPANY.CRC_TEXT" />
                                        </h4>
                                    </div>
                                </Paper>
                            )}
                        </div>
                        <div className={classes.user} onClick={() => goToCompany()}>
                            {loading && <CircularProgress size={12} />}
                            {!loading && (
                                <>
                                    <strong className={classes.name}>{name}</strong>
                                    <p className={classes.email}>{email}</p>
                                </>
                            )}
                        </div>
                        <UserPopover onProfile={handleProfile} />
                        {process.env.NODE_ENV === 'development' && DEV_ENVIRONMENT && <MenuDev />}
                    </div>
                </Toolbar>
            </AppBar>
        </Paper>
    );
}

export default Header;
